<template>
  <div class="app-layout">
    <div class="app-layout-grid">
      <div class="list px-3 py-3">
        <v-card elevation="0" class="card-box-shadow mb-3">
          <v-card-title>
            <v-row no-gutters>
              <v-col cols="4">
                <h5>{{ tripModule.tripPlural }} ({{ totalCount }})</h5>
              </v-col>
              <v-col cols="6" class="text-right"> </v-col>
              <v-col cols="2" class="text-right"> </v-col>
            </v-row>
          </v-card-title>
          <v-card-text class="d-flex py-0 app-custom-search-input">
            <v-text-field
              id="search"
              class="mr-1"
              :label="`search ${tripModule.trip}`"
              prepend-inner-icon="mdi-magnify"
              color="secondary"
              background-color="background_color"
              outlined
              dense
              height="5px"
              v-model="search"
              hide-details="auto"
              @keydown.enter="getTripList(true)"
            >
            </v-text-field>

            <ConsigneeTripFilter
              :filter="tripFilters"
              @apply="getTripList(true)"
              @reset="resetFilter"
              :isChips="Object.keys(this.tripFilters).length > 0"
            />

            <v-tooltip bottom>
              <template v-slot:activator="{ on, attrs }">
                <v-btn
                  id="tripRefreshList"
                  class="h-100 btn-box background_color primary--text"
                  v-bind="attrs"
                  v-on="on"
                  depressed
                  @click="getTripList(true)"
                >
                  <v-icon small>mdi-refresh</v-icon>
                </v-btn>
              </template>
              <span class="text-capitalize">refresh trips</span>
            </v-tooltip>
          </v-card-text>
          <v-card-text style="height: 50px">
            <ChipsWithTooltip
              v-for="(value, key, index) in tripFilters"
              :key="index"
              :keyToDisplay="key"
              :valueToDisplay="value"
              @remove="removeFilter"
            />
          </v-card-text>
        </v-card>
        <v-card
          elevation="0"
          class="card-box-shadow overflow-y-auto app-list"
          style="overflow-y: auto; height: calc(100vh - 250px)"
          id="trip-target"
        >
          <v-expansion-panels
            v-model="tripExpansion"
            flat
            multiple
            class="background_color app-list-card-expansion"
            v-scroll:#trip-target="onTripScroll"
          >
            <v-expansion-panel
              elevation="0"
              v-for="(trip, i) in tripList"
              :key="i"
              class="px-3 py-1 ma-0 mb-2 card-box-shadow"
            >
              <TripListCard :trip="trip" @selectedTrip="getAllData" />
            </v-expansion-panel>
          </v-expansion-panels>
        </v-card>
      </div>
      <div>
        <ConsigneeTripDetails
          ref="ConsigneeTripDetails"
          @getList="getTripList"
        />
      </div>
    </div>
  </div>
</template>

<script>
import { bus } from "@/main";
import BaseCard from "@/components/BaseComponents/BaseCard.vue";
import GoogleMap from "@/components/BaseComponents/GoogleMap.vue";
import MapInfo from "@/components/BaseComponents/MapInfo.vue";
import TripListCard from "@/components/ModuleBasedComponents/Trip/TripListCard.vue";
import TripTooltipWithIcon from "@/components/ModuleBasedComponents/Trip/TripTooltipWithIcon.vue";
import ConsigneeTripFilter from "@/components/ModuleBasedComponents/Consignee/ConsigneeTripFilter.vue";
import TripSummary from "@/components/ModuleBasedComponents/Trip/TripSummary.vue";
import ChipsWithTooltip from "@/components/BaseComponents/ChipsWithTooltip.vue";
import ConsigneeTripDetails from "@/components/ModuleBasedComponents/Consignee/ConsigneeTripDetails.vue";
import { filterModules } from "@/utils/fieldConstants";
import { mapState } from "vuex";
import { tripModule } from "@/utils/moduleMapping";

export default {
  components: {
    BaseCard,
    GoogleMap,
    MapInfo,
    TripListCard,
    TripTooltipWithIcon,
    ConsigneeTripFilter,
    TripSummary,
    ChipsWithTooltip,
    ConsigneeTripDetails,
  },
  props: {
    data: Object,
  },
  data() {
    return {
      tripModule,
      permissions: null,
      tripExpansion: [0],
      tripList: [],
      search: null,
      isTripListScrollable: true,
      totalCount: 0,
      buttonTooltip: "Add Trips",
    };
  },
  computed: {
    profileObject() {
      let obj = localStorage.getItem("user_data");
      return obj ? JSON.parse(obj) : null;
    },
    ...mapState("userProfile", {
      tripFilters: (state) => state.trip_filters,
    }),
  },
  methods: {
    onTripScroll(e) {
      let scroll =
        parseInt(e.target.scrollHeight) -
        parseInt(e.target.scrollTop + e.target.clientHeight);
      if (scroll < 4 && this.isTripListScrollable) {
        this.isTripListScrollable = false;
        this.getTripList();
      }
    },
    removeFilter(key) {
      this.$store.commit("userProfile/removeFilter", {
        moduleKey: "trip_filters",
        filterKey: key,
      });
      this.getTripList(true);
    },
    resetFilter() {
      this.$store.commit("userProfile/resetFilters", {
        moduleKey: "trip_filters",
      });
      this.getTripList(true);
    },
    getAllData(id) {
      this.$refs.ConsigneeTripDetails.getData(id);
    },
    async getTripList(reload, params = {}) {
      params = {
        ...params,
        offset: reload ? 0 : this.tripList.length,
        limit: 50,
        ...this.tripFilters,
      };

      if (this.search) {
        params.search = this.search;
      }

      if (params && params.status && params.status.length > 0) {
        params.status = params.status.join(",");
      }

      // if ("ordering" in params && params.ordering.length > 0) {
      //   params = { ...params, ordering: params.ordering.join(",") };
      // }

      if (reload || this.totalCount != this.tripList.length) {
        bus.$emit("showLoader", true);
        this.$api.consigneeManagement
          .getConsigneeTripList(params)
          .then((res) => {
            bus.$emit("showLoader", false);
            if (reload) {
              this.tripList = res.data;
            } else {
              this.tripList = [...this.tripList, ...res.data];
            }
            this.totalCount = res.count;
            if (this.totalCount != this.tripList.length) {
              this.isTripListScrollable = true;
            }
          })
          .catch((err) => {
            console.log(err);
            bus.$emit("showLoader", false);
          });
      }
    },
  },
  async mounted() {
    if (this.data && this.data.id) {
      // this.search = this.data.reference_number;
      // this.getAllData(this.data.id);
      await this.getTripList(true);
    } else {
      await this.getTripList(true);
    }
  },
};
</script>

<style>
.app-layout .v-card {
  /* border: 11px solid green; */
}
.v-expansion-panel-header {
  min-height: 30px !important;
}

.sticky-top {
  position: sticky;
  top: 0;
  z-index: 3;
}
</style>
